import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-screen-xl mx-auto py-14 px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

          <div className="flex flex-col items-center md:items-start">
            <span className="text-red-500 font-bold text-2xl mb-4">Kontakt</span>
            <div className="space-y-2 text-sm">
              <div className="flex items-start gap-2">
                <FaMapMarkerAlt className="mt-1 text-red-500 flex-shrink-0" />
                <div>
                  Petromin s.r.o.<br />
                  Prešovská 539<br />
                  087 01 Giraltovce
                </div>
              </div>
              <a href="tel:+421918495001" className="flex items-center gap-2 hover:text-white transition-colors duration-200">
                <FaPhone className="text-red-500 flex-shrink-0" />
                0918 495 001
              </a>
              <a href="tel:+421908174155" className="flex items-center gap-2 hover:text-white transition-colors duration-200">
                <FaPhone className="text-red-500 flex-shrink-0" />
                0908 174 155
              </a>
              <a href="mailto:petromin@petromin.sk" className="flex items-center gap-2 hover:text-white transition-colors duration-200">
                <FaEnvelope className="text-red-500 flex-shrink-0" />
                petromin@petromin.sk
              </a>
            </div>
          </div>

          <div className="flex flex-col items-center md:items-start">
            <span className="text-red-500 font-bold text-2xl mb-4">Naša ponuka</span>
            <ul className="space-y-2 text-sm">
              <li><Link to="/ponuka/strkopiesky" className="hover:text-white transition-colors duration-200">Štrkopiesky</Link></li>
              <li><Link to="/ponuka/piesok" className="hover:text-white transition-colors duration-200">Piesok</Link></li>
              <li><Link to="/ponuka/okrasny" className="hover:text-white transition-colors duration-200">Okrasný kameň</Link></li>
              <li><Link to="/ponuka/kamenivo" className="hover:text-white transition-colors duration-200">Kamenivo</Link></li>
              <li><Link to="/doprava" className="hover:text-white transition-colors duration-200">Doprava</Link></li>
            </ul>
          </div>

          <div className="flex flex-col items-center md:items-start">
            <span className="text-red-500 font-bold text-2xl mb-4">O firme</span>
            <p className="text-sm leading-relaxed mb-6">
              Petromin s.r.o. je spoločnosť, ktorá sa špecializuje na dodávku stavebných materiálov a dopravu. Ponúkame široký sortiment kvalitných produktov pre vaše projekty.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="Facebook"
              >
                <FaFacebook className="text-2xl" />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="Instagram"
              >
                <FaInstagram className="text-2xl" />
              </a>
            </div>
          </div>

        </div>

        <div className="border-t border-gray-700 mt-10 pt-6 text-center text-sm text-gray-500">
          Petromin s.r.o. © 2026 | Všetky práva vyhradené
        </div>
      </div>
    </footer>
  );
}

export default Footer;
